$('.mobile-menu').click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('header .center').removeClass('show-menu');
    } else {
        $(this).addClass('active');
        $('header .center').addClass('show-menu');
    }
});





// WEBPACK FOOTER //
// ./resources/js/snippets/mobile-menu.js